import { resolveValueTypeToString } from './resolveValueType';
export const mapToAttributeStringValue = (attrValue) => ({
    ...attrValue,
    value: resolveValueTypeToString(attrValue.value),
});
//# sourceMappingURL=mapToAttributeStringValue.js.map